import { render, staticRenderFns } from "./feeReceiptList.vue?vue&type=template&id=710bdc4c&scoped=true"
import script from "./feeReceiptList.vue?vue&type=script&lang=js"
export * from "./feeReceiptList.vue?vue&type=script&lang=js"
import style0 from "./feeReceiptList.vue?vue&type=style&index=0&id=710bdc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bdc4c",
  null
  
)

export default component.exports